var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.380859,
    y: 0.934814,
    width: 16,
    height: 17.9349,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_782_2046",
    transform: "matrix(0.015625 0 0 0.0139393 0 0.0539419)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_782_2046",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAE6UlEQVR4nO2bW0wcVRjH/2dmZ4BldxFojVCoLZcFmra2tqaNRhMtrgFqELdrbdU0mvTBB3npg6mXhtQLmiiJ8KC+9MEqRhEvoVobuTS1GtNSqbFaRVOg3bqt9UJgd1t2d+b4QGdhsdAzyxmGy/yezpz5vu985885Z/iGAbCwWNAQvQ4VFY+4omSkFgQPACgFkM4/rUkJAfQ8COmlKg4oIJ8d/qLlwnQC6hLAU+ndoBLyCYCc6QzKkSsA3owJ0suH297/K5kAzAJ47veWqir5DkBGMgMZTEAFtnR+/tG3eh2ZBSiv8nUC9G4AcDod2Pn4Y9iwfi2ysjL1jqmbd5o/xP7mFgBAxX2b4C4qwKGvuvBL7+/jzSJUoFs72lo/1RNbYDEqr9papk1eFEXU730WFZ57ZmTyE1mUnYXNFR40NdTj+d274HI6tVsyUcn+8krfKj3xmAQA1Du11m3r1qKkuEjPGIZx1x0b0fj6S1iUnaV1OQD6bl1dHeO8WAWg9EatufzmfF1J8kAUxHg7Fo0l3FuSm4O9e56GzWYb7SBYfbT71KOssdkEEGDTmjbJNpWlIWRmjp27fQNn/3e/uLAA3uqqsQ6Kp1hjMy8VM1m5oizePn7i5MTDDwBQU10FUYyvlHWe6oeZluqcEGBp/hKsuWUlAEBRFOze8yIOHurA3//8G7fJzspESXGhdkkURbmdJbbh63kkEsWAP4DIhL17PWRJwrK8myDLEgCg9smdqN31DIKhEILBEBqa3prSn6hYyjKO4StgOBjWPXkAiESjGAqG49f5ebmof+E5ZLM+egXqYjLTnZlOnA47ZEnS7SdLElwOe0JfqbsI+95+A0/s2I6S4iKkpaZO4k1OCYTsYxnH8C2QIktwF/B7dNrT0rDNV4NtvppJbQghzL8MzYlD0EgsAcxOgCeUUrR3HkF5pW87GAu9eSVAe9cRvNrQBBD63qbNvodYfOaVAIELF+NtAlo2hWmceSVAMlgCmJ2A2VgCmJ2A2Sx4AbjWAsmWvqxMLJF5wHUFJFv6sjKxROYBVwGSLX1ZuVaJPF24bgHepe9MsOAPQUsAsxMwG+6vxAaHgojGjHkSSDYbbnA5uMbkKsDg0DD8gUs8Q14TniJw3gK6PzgxHa4rQPvJjIxEeIaNk5Iiz+4tAPBdnjPBgn8KWAKYnYDZcD0DYjEF/f4AriR5CBJCkOF0IC9ncUJ/JBJFv3/0c8BZXQ4Hw5eTnjww+oeNwaFhqKqa0D8UDCMSjY6Ww6FZXA477GlITZGT9ieEIDPDCUFITMvlsEOWJcjyLC+HbTYRRcvyeIYEAMiyBPdyY8rsBX8IWgKYnYDZWAKYnYDZWAKYnYDZsAmgIv6OS1EUw5KZLgkfUo/LeSrYBCDkT605cNavM62Zo2/g3NiFQC9ObjnOjMVIEdRvtPax7h6c/yOgNzfDOdPXj+7ve+LXAsHXLH7i9U2A/t7TlwrdKzwA8lVVxQ8//oRb16we/98aphEOX8axEz145bVGBK8WSpSgs/1AawOLP/NbzHsrvespIUcBpACjhUt6Ot/CJBlCoTAopeO7BhWFbOz6suVXFn9dr3HLq7Y8CKAZV0WYdVB6jorU29H28XFWF6YtoHHmt59PF7hXtQJ0MYBcAGl6czSAIAFOUoJGMWrf0X7wg36zE7KwmEP8By0rWvfFjls/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/Page.fbb2fd49f54577bd2466643651a66949.svg";
export { ForwardRef as ReactComponent };